// Componente de skeleton para el módulo de Logística - Skeleton component for Logistics module
// Muestra placeholders que respetan la estructura de los bloques de la página
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const LogisticsSkeleton = () => {
  return (
    <div className="px-6 py-4 space-y-6">
      {/* Barra de filtros Skeleton - Filters bar skeleton */}
      <div className="mb-4 flex flex-col sm:flex-row items-start sm:items-end gap-3 flex-wrap">
        {/* Filtro de fecha - Date filter */}
        <div className="flex items-end gap-2 flex-1 min-w-[300px]">
          <div className="flex-1">
            <Skeleton className="h-3 w-12 rounded-full mb-1.5 bg-hover-press" />
            <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
          </div>
          <div className="w-[180px] flex-shrink-0">
            <Skeleton className="h-3 w-16 rounded-full mb-1.5 bg-hover-press" />
            <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
          </div>
        </div>

        {/* Filtros adicionales - Additional filters */}
        <div className="flex items-end gap-2 flex-wrap">
          <div className="w-[180px]">
            <Skeleton className="h-3 w-24 rounded-full mb-1.5 bg-hover-press" />
            <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
          </div>
          <div className="w-[180px]">
            <Skeleton className="h-3 w-12 rounded-full mb-1.5 bg-hover-press" />
            <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
          </div>
          <div className="w-[180px]">
            <Skeleton className="h-3 w-14 rounded-full mb-1.5 bg-hover-press" />
            <Skeleton className="h-10 w-full rounded-md bg-hover-press" />
          </div>
          <Skeleton className="h-10 w-10 rounded-md bg-hover-press" />
        </div>
      </div>

      {/* LogisticsMetrics Skeleton - 4 métricas en grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((index) => (
          <SectionBox key={index} className="bg-card-bg">
            <div className="flex items-center gap-3">
              {/* Icono - Icon */}
              <Skeleton className="w-8 h-8 rounded-md bg-hover-press flex-shrink-0" />
              {/* Información - Information */}
              <div className="flex-1 space-y-2">
                <Skeleton className="h-3 w-20 rounded-full bg-hover-press" />
                <Skeleton className="h-5 w-16 rounded-full bg-hover-press" />
              </div>
            </div>
          </SectionBox>
        ))}
      </div>

      {/* OrdersChartsSection Skeleton - 2 gráficos (60/40) */}
      <div className="grid grid-cols-1 lg:grid-cols-10 gap-6">
        {/* Gráfico de líneas - Line chart (60%) */}
        <div className="lg:col-span-6 min-w-0">
          <SectionBox className="bg-card-bg">
            {/* Header del gráfico - Chart header */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Skeleton className="h-5 w-40 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="h-8 w-24 rounded-md bg-hover-press" />
                <Skeleton className="h-8 w-24 rounded-md bg-hover-press" />
              </div>
            </div>
            {/* Área del gráfico - Chart area */}
            <Skeleton className="h-[300px] w-full rounded-md bg-hover-press" />
          </SectionBox>
        </div>

        {/* Gráfico de donut - Donut chart (40%) */}
        <div className="lg:col-span-4 min-w-0">
          <SectionBox className="bg-card-bg h-full">
            {/* Header del gráfico - Chart header */}
            <div className="flex items-center gap-2 mb-4">
              <Skeleton className="h-5 w-32 rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
            </div>
            {/* Área del donut - Donut area */}
            <div className="flex flex-col items-center justify-center">
              <Skeleton className="h-[200px] w-[200px] rounded-full bg-hover-press" />
              {/* Leyenda - Legend */}
              <div className="mt-4 space-y-2 w-full">
                {[1, 2, 3, 4].map((index) => (
                  <div key={index} className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Skeleton className="h-3 w-3 rounded-full bg-hover-press" />
                      <Skeleton className="h-3 w-20 rounded-full bg-hover-press" />
                    </div>
                    <Skeleton className="h-3 w-12 rounded-full bg-hover-press" />
                  </div>
                ))}
              </div>
            </div>
          </SectionBox>
        </div>
      </div>

      {/* ProductStatisticsSection Skeleton - Sección de estadísticas por producto */}
      <SectionBox className="bg-card-bg">
        {/* Header con título - Header with title */}
        <div className="flex items-center gap-2 mb-4">
          <Skeleton className="h-6 w-48 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-4 rounded-full bg-hover-press" />
        </div>

        {/* Barra de controles - Controls bar */}
        <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
          {/* Controles izquierda - Left controls */}
          <div className="flex items-center gap-3 flex-wrap">
            <Skeleton className="h-10 w-64 rounded-md bg-hover-press" />
            <Skeleton className="h-10 w-32 rounded-md bg-hover-press" />
            <Skeleton className="h-10 w-36 rounded-md bg-hover-press" />
          </div>
          {/* Total de resultados - Total results */}
          <Skeleton className="h-5 w-24 rounded-full bg-hover-press" />
        </div>

        {/* Tabla Skeleton - Table skeleton */}
        <div className="space-y-3">
          {/* Header de tabla - Table header */}
          <div className="grid grid-cols-5 gap-4 pb-3 border-b border-card-border">
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-16 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
            <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
          </div>
          {/* Filas de tabla - Table rows */}
          {[1, 2, 3, 4, 5].map((index) => (
            <div key={index} className="grid grid-cols-5 gap-4 py-3 border-b border-card-border last:border-b-0">
              {/* Columna de producto - Product column */}
              <div className="flex items-center gap-3">
                <Skeleton className="h-10 w-10 rounded-md bg-hover-press flex-shrink-0" />
                <div className="space-y-1.5 flex-1 min-w-0">
                  <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                  <Skeleton className="h-3 w-20 rounded-full bg-hover-press" />
                </div>
              </div>
              {/* Otras columnas - Other columns */}
              <Skeleton className="h-5 w-12 rounded-full bg-hover-press" />
              <div className="space-y-1">
                <Skeleton className="h-4 w-10 rounded-full bg-hover-press" />
                <Skeleton className="h-3 w-14 rounded-full bg-hover-press" />
              </div>
              <div className="space-y-1">
                <Skeleton className="h-4 w-10 rounded-full bg-hover-press" />
                <Skeleton className="h-3 w-14 rounded-full bg-hover-press" />
              </div>
              <div className="space-y-1">
                <Skeleton className="h-4 w-10 rounded-full bg-hover-press" />
                <Skeleton className="h-3 w-14 rounded-full bg-hover-press" />
              </div>
            </div>
          ))}
        </div>
      </SectionBox>
    </div>
  );
};
